var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewDesignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4173 2.94727L7.13411 4.57387C6.55286 4.68802 6.09322 5.13354 5.961 5.71095L5.07587 9.57639L8.78818 13.2887L12.6536 12.4036C13.231 12.2714 13.6766 11.8117 13.7907 11.2305L15.4173 2.94727ZM15.4173 2.94727L11.4398 6.92474M11.1747 9.31123C10.5889 9.89701 9.63913 9.89701 9.05334 9.31123C8.46756 8.72544 8.46756 7.77569 9.05334 7.18991C9.63913 6.60412 10.5889 6.60412 11.1747 7.18991C11.7604 7.77569 11.7604 8.72544 11.1747 9.31123ZM2.68934 11.4325L6.93198 15.6751C7.51777 16.2609 8.46751 16.2609 9.0533 15.6751C9.63909 15.0893 9.63909 14.1396 9.0533 13.5538L4.81066 9.31117C4.22487 8.72538 3.27513 8.72538 2.68934 9.31117C2.10355 9.89695 2.10355 10.8467 2.68934 11.4325Z",
    stroke: "#949BA5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDesignIcon);
export default __webpack_public_path__ + "static/media/NewDesignIcon.fd3018fd129472c98d807a0e6fc3acfa.svg";
export { ForwardRef as ReactComponent };